'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var defaultMigrations = require('../migrations');

var repoVersion = require('./repo/version');

var repoLock = require('./repo/lock');

var errors = require('./errors');

var log = require('debug')('repo-migrations:migrator');

exports.getCurrentRepoVersion = repoVersion.getVersion;
exports.errors = errors;
/**
 * Returns the version of latest migration.
 * If no migrations are present returns 0.
 *
 * @param {array?} migrations - Array of migrations to consider. If undefined, the bundled migrations are used. Mainly for testing purpose.
 * @returns {int}
 */

function getLatestMigrationVersion(migrations) {
  migrations = migrations || defaultMigrations;

  if (!Array.isArray(migrations) || migrations.length === 0) {
    return 0;
  }

  return migrations[migrations.length - 1].version;
}

exports.getLatestMigrationVersion = getLatestMigrationVersion;
/**
 * Main function to execute forward migrations.
 * It acquire lock on the provided path before doing any migrations.
 *
 * Signature of the progress callback is: function(migrationObject: object, currentMigrationNumber: int, totalMigrationsCount: int)
 *
 * @param {string} path - Path to initialized (!) JS-IPFS repo
 * @param {int} toVersion - Version to which the repo should be migrated.
 * @param {Object} options - Options for migration
 * @param {boolean?} options.ignoreLock - Won't lock the repo for applying the migrations. Use with caution.
 * @param {object?} options.repoOptions - Options that are passed to migrations, that can use them to correctly construct datastore. Options are same like for IPFSRepo.
 * @param {function?} options.onProgress - Callback which will be called after each executed migration to report progress
 * @param {boolean?} options.isDryRun - Allows to simulate the execution of the migrations without any effect.
 * @param {array?} options.migrations - Array of migrations to migrate. If undefined, the bundled migrations are used. Mainly for testing purpose.
 * @returns {Promise<void>}
 */

function migrate(_x, _x2, _x3) {
  return _migrate.apply(this, arguments);
}

function _migrate() {
  _migrate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path, toVersion, _ref) {
    var _ref$ignoreLock, ignoreLock, repoOptions, onProgress, _ref$isDryRun, isDryRun, migrations, currentVersion, lock, counter, totalMigrations, _iterator2, _step2, migration, lastSuccessfullyMigratedVersion;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref$ignoreLock = _ref.ignoreLock, ignoreLock = _ref$ignoreLock === void 0 ? false : _ref$ignoreLock, repoOptions = _ref.repoOptions, onProgress = _ref.onProgress, _ref$isDryRun = _ref.isDryRun, isDryRun = _ref$isDryRun === void 0 ? false : _ref$isDryRun, migrations = _ref.migrations;
            migrations = migrations || defaultMigrations;

            onProgress = onProgress || function () {};

            if (path) {
              _context.next = 5;
              break;
            }

            throw new errors.RequiredParameterError('Path argument is required!');

          case 5:
            if (toVersion) {
              _context.next = 7;
              break;
            }

            throw new errors.RequiredParameterError('toVersion argument is required!');

          case 7:
            if (!(!Number.isInteger(toVersion) || toVersion <= 0)) {
              _context.next = 9;
              break;
            }

            throw new errors.InvalidValueError('Version has to be positive integer!');

          case 9:
            _context.next = 11;
            return repoVersion.getVersion(path);

          case 11:
            currentVersion = _context.sent;

            if (!(currentVersion === toVersion)) {
              _context.next = 15;
              break;
            }

            log('Nothing to migrate.');
            return _context.abrupt("return");

          case 15:
            if (!(currentVersion > toVersion)) {
              _context.next = 17;
              break;
            }

            throw new errors.InvalidValueError("Current repo's version (".concat(currentVersion, ") is higher then toVersion (").concat(toVersion, "), you probably wanted to revert it?"));

          case 17:
            verifyAvailableMigrations(migrations, currentVersion, toVersion);

            if (!(!isDryRun && !ignoreLock)) {
              _context.next = 22;
              break;
            }

            _context.next = 21;
            return repoLock.lock(currentVersion, path);

          case 21:
            lock = _context.sent;

          case 22:
            _context.prev = 22;
            counter = 0;
            totalMigrations = toVersion - currentVersion;
            _iterator2 = _createForOfIteratorHelper(migrations);
            _context.prev = 26;

            _iterator2.s();

          case 28:
            if ((_step2 = _iterator2.n()).done) {
              _context.next = 54;
              break;
            }

            migration = _step2.value;

            if (!(toVersion !== undefined && migration.version > toVersion)) {
              _context.next = 32;
              break;
            }

            return _context.abrupt("break", 54);

          case 32:
            if (!(migration.version <= currentVersion)) {
              _context.next = 34;
              break;
            }

            return _context.abrupt("continue", 52);

          case 34:
            counter++;
            log("Migrating version ".concat(migration.version));
            _context.prev = 36;

            if (isDryRun) {
              _context.next = 40;
              break;
            }

            _context.next = 40;
            return migration.migrate(path, repoOptions);

          case 40:
            _context.next = 50;
            break;

          case 42:
            _context.prev = 42;
            _context.t0 = _context["catch"](36);
            lastSuccessfullyMigratedVersion = migration.version - 1;
            log("An exception was raised during execution of migration. Setting the repo's version to last successfully migrated version: ".concat(lastSuccessfullyMigratedVersion));
            _context.next = 48;
            return repoVersion.setVersion(path, lastSuccessfullyMigratedVersion);

          case 48:
            _context.t0.message = "During migration to version ".concat(migration.version, " exception was raised: ").concat(_context.t0.message);
            throw _context.t0;

          case 50:
            onProgress(migration, counter, totalMigrations); // Reports on migration process

            log("Migrating to version ".concat(migration.version, " finished"));

          case 52:
            _context.next = 28;
            break;

          case 54:
            _context.next = 59;
            break;

          case 56:
            _context.prev = 56;
            _context.t1 = _context["catch"](26);

            _iterator2.e(_context.t1);

          case 59:
            _context.prev = 59;

            _iterator2.f();

            return _context.finish(59);

          case 62:
            if (isDryRun) {
              _context.next = 65;
              break;
            }

            _context.next = 65;
            return repoVersion.setVersion(path, toVersion || getLatestMigrationVersion(migrations));

          case 65:
            log('Repo successfully migrated ', toVersion !== undefined ? "to version ".concat(toVersion, "!") : 'to latest version!');

          case 66:
            _context.prev = 66;

            if (!(!isDryRun && !ignoreLock)) {
              _context.next = 70;
              break;
            }

            _context.next = 70;
            return lock.close();

          case 70:
            return _context.finish(66);

          case 71:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[22,, 66, 71], [26, 56, 59, 62], [36, 42]]);
  }));
  return _migrate.apply(this, arguments);
}

exports.migrate = migrate;
/**
 * Main function to execute backward migration (reversion).
 * It acquire lock on the provided path before doing any migrations.
 *
 * Signature of the progress callback is: function(migrationObject: object, currentMigrationNumber: int, totalMigrationsCount: int)
 *
 * @param {string} path - Path to initialized (!) JS-IPFS repo
 * @param {int} toVersion - Version to which the repo will be reverted.
 * @param {Object} options - Options for the reversion
 * @param {function?} options.onProgress - Callback which will be called after each reverted migration to report progress
 * @param {object?} options.repoOptions - Options that are passed to migrations, that can use them to correctly construct datastore. Options are same like for IPFSRepo.
 * @param {boolean?} options.isDryRun - Allows to simulate the execution of the reversion without any effects. Make sense to utilize onProgress with this argument.
 * @param {boolean?} options.ignoreLock - Won't lock the repo for reverting the migrations. Use with caution.
 * @param {array?} options.migrations - Array of migrations to migrate. If undefined, the bundled migrations are used. Mainly for testing purpose.
 * @returns {Promise<void>}
 */

function revert(_x4, _x5, _x6) {
  return _revert.apply(this, arguments);
}

function _revert() {
  _revert = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(path, toVersion, _ref2) {
    var _ref2$ignoreLock, ignoreLock, repoOptions, onProgress, _ref2$isDryRun, isDryRun, migrations, currentVersion, lock, counter, totalMigrations, reversedMigrationArray, _iterator3, _step3, migration, lastSuccessfullyRevertedVersion;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _ref2$ignoreLock = _ref2.ignoreLock, ignoreLock = _ref2$ignoreLock === void 0 ? false : _ref2$ignoreLock, repoOptions = _ref2.repoOptions, onProgress = _ref2.onProgress, _ref2$isDryRun = _ref2.isDryRun, isDryRun = _ref2$isDryRun === void 0 ? false : _ref2$isDryRun, migrations = _ref2.migrations;
            migrations = migrations || defaultMigrations;

            onProgress = onProgress || function () {};

            if (path) {
              _context2.next = 5;
              break;
            }

            throw new errors.RequiredParameterError('Path argument is required!');

          case 5:
            if (toVersion) {
              _context2.next = 7;
              break;
            }

            throw new errors.RequiredParameterError('When reverting migrations, you have to specify to which version to revert!');

          case 7:
            if (!(!Number.isInteger(toVersion) || toVersion <= 0)) {
              _context2.next = 9;
              break;
            }

            throw new errors.InvalidValueError('Version has to be positive integer!');

          case 9:
            _context2.next = 11;
            return repoVersion.getVersion(path);

          case 11:
            currentVersion = _context2.sent;

            if (!(currentVersion === toVersion)) {
              _context2.next = 15;
              break;
            }

            log('Nothing to revert.');
            return _context2.abrupt("return");

          case 15:
            if (!(currentVersion < toVersion)) {
              _context2.next = 17;
              break;
            }

            throw new errors.InvalidValueError("Current repo's version (".concat(currentVersion, ") is lower then toVersion (").concat(toVersion, "), you probably wanted to migrate it?"));

          case 17:
            verifyAvailableMigrations(migrations, toVersion, currentVersion, true);

            if (!(!isDryRun && !ignoreLock)) {
              _context2.next = 22;
              break;
            }

            _context2.next = 21;
            return repoLock.lock(currentVersion, path);

          case 21:
            lock = _context2.sent;

          case 22:
            log("Reverting from version ".concat(currentVersion, " to ").concat(toVersion));
            _context2.prev = 23;
            counter = 0;
            totalMigrations = currentVersion - toVersion;
            reversedMigrationArray = migrations.slice().reverse();
            _iterator3 = _createForOfIteratorHelper(reversedMigrationArray);
            _context2.prev = 28;

            _iterator3.s();

          case 30:
            if ((_step3 = _iterator3.n()).done) {
              _context2.next = 56;
              break;
            }

            migration = _step3.value;

            if (!(migration.version <= toVersion)) {
              _context2.next = 34;
              break;
            }

            return _context2.abrupt("break", 56);

          case 34:
            if (!(migration.version > currentVersion)) {
              _context2.next = 36;
              break;
            }

            return _context2.abrupt("continue", 54);

          case 36:
            counter++;
            log("Reverting migration version ".concat(migration.version));
            _context2.prev = 38;

            if (isDryRun) {
              _context2.next = 42;
              break;
            }

            _context2.next = 42;
            return migration.revert(path, repoOptions);

          case 42:
            _context2.next = 52;
            break;

          case 44:
            _context2.prev = 44;
            _context2.t0 = _context2["catch"](38);
            lastSuccessfullyRevertedVersion = migration.version;
            log("An exception was raised during execution of migration. Setting the repo's version to last successfully reverted version: ".concat(lastSuccessfullyRevertedVersion));
            _context2.next = 50;
            return repoVersion.setVersion(path, lastSuccessfullyRevertedVersion);

          case 50:
            _context2.t0.message = "During reversion to version ".concat(migration.version, " exception was raised: ").concat(_context2.t0.message);
            throw _context2.t0;

          case 52:
            onProgress(migration, counter, totalMigrations); // Reports on migration process

            log("Reverting to version ".concat(migration.version, " finished"));

          case 54:
            _context2.next = 30;
            break;

          case 56:
            _context2.next = 61;
            break;

          case 58:
            _context2.prev = 58;
            _context2.t1 = _context2["catch"](28);

            _iterator3.e(_context2.t1);

          case 61:
            _context2.prev = 61;

            _iterator3.f();

            return _context2.finish(61);

          case 64:
            if (isDryRun) {
              _context2.next = 67;
              break;
            }

            _context2.next = 67;
            return repoVersion.setVersion(path, toVersion);

          case 67:
            log("All migrations successfully reverted to version ".concat(toVersion, "!"));

          case 68:
            _context2.prev = 68;

            if (!(!isDryRun && !ignoreLock)) {
              _context2.next = 72;
              break;
            }

            _context2.next = 72;
            return lock.close();

          case 72:
            return _context2.finish(68);

          case 73:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[23,, 68, 73], [28, 58, 61, 64], [38, 44]]);
  }));
  return _revert.apply(this, arguments);
}

exports.revert = revert;
/**
 * Function checks if all migrations in given range are available.
 *
 * @param {array} migrations
 * @param {int} fromVersion
 * @param {int} toVersion
 * @param {boolean} checkReversibility - Will additionally checks if all the migrations in the range are reversible
 * @returns {void}
 */

function verifyAvailableMigrations(migrations, fromVersion, toVersion) {
  var checkReversibility = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var migrationCounter = 0;

  var _iterator = _createForOfIteratorHelper(migrations),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var migration = _step.value;

      if (migration.version > toVersion) {
        break;
      }

      if (migration.version > fromVersion) {
        if (checkReversibility && !migration.revert) {
          throw new errors.NonReversibleMigrationError("It is not possible to revert to version ".concat(fromVersion, " because migration version ").concat(migration.version, " is not reversible. Cancelling reversion."));
        }

        migrationCounter++;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  if (migrationCounter !== toVersion - fromVersion) {
    throw new errors.InvalidValueError("The ipfs-repo-migrations package does not have all migration to migrate from version ".concat(fromVersion, " to ").concat(toVersion));
  }
}